import { ReactNode } from "react";

import Typography from "../typography";
import { cn } from "../../utls/utils";

export type DetailItemLayout = "inline" | "stack";

export interface DetailItemProps {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  helperText?: ReactNode;
  layout?: DetailItemLayout;
  className?: string;
}

const layoutClasses: Record<DetailItemLayout, string> = {
  inline: "sm:grid sm:grid-cols-[minmax(0,220px)_1fr] sm:items-start sm:gap-6",
  stack: "flex flex-col",
};

export function DetailItem({
  label,
  value,
  icon,
  helperText,
  layout = "inline",
  className,
}: DetailItemProps) {
  const isPrimitiveValue =
    typeof value === "string" || typeof value === "number";

  return (
    <div
      className={cn(
        "rounded-xl border border-beige-200 bg-white p-4 shadow-sm",
        layoutClasses[layout],
        "gap-4",
        className
      )}
    >
      <div className="flex items-start gap-3 text-brown-700">
        {icon ? (
          <span
            aria-hidden
            className="mt-1 flex h-9 w-9 items-center justify-center rounded-full bg-terracotta-50 text-terracotta-600"
          >
            {icon}
          </span>
        ) : null}
        <div className="space-y-1">
          <Typography variant="subtitle2" className="text-terracotta-700">
            {label}
          </Typography>
          {helperText ? (
            <Typography variant="caption" className="text-brown-500">
              {helperText}
            </Typography>
          ) : null}
        </div>
      </div>
      <div className="space-y-1 text-brown-800">
        {isPrimitiveValue ? (
          <Typography variant="body2" className="text-brown-800">
            {value}
          </Typography>
        ) : (
          value
        )}
      </div>
    </div>
  );
}

export default DetailItem;
